import {
  UseUserCalendarReturnData,
  UseUserCalendarReturnDataItem
} from 'modules/calendar/hooks/useUserCalendar';

// Neither side controls the casing — the API stores what the ATS sent, the
// calendar list what the provider sent — so a case-sensitive match drops people.
export const findCalendarByEmail = (
  userCalendars: UseUserCalendarReturnData,
  email: string | null | undefined
): UseUserCalendarReturnDataItem | undefined =>
  email
    ? userCalendars.find(
        (calendar) => calendar.email?.toLowerCase() === email.toLowerCase()
      )
    : undefined;
